import React, { useEffect } from "react";
import { updateEnv } from "../../store/slices/CreateApplicationSlice";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../store/store";
import { MenuItem, Select } from "@mui/material";
import { BrowserStorage } from "../../utils/browserStorage";
import { useNavigate } from "react-router-dom";
import { getEnv } from "../../Constants/env";

interface SitLoginScreenProps {
  env: string;
  setEnv: (value: string) => void;
}

const SitLoginScreen: React.FC<SitLoginScreenProps> = ({ env, setEnv }) => {
  const dispatch = useDispatch<AppDispatch>();
  const navigate = useNavigate();
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const rawEnvType = getEnv()?.envtype?.toLowerCase();
  const globalEnvType = rawEnvType === "local" ? "dev" : rawEnvType;
  const deploymentEnv = globalEnvType?.toUpperCase() || "";

  // Only SIT, PROD, and local/dev allow switching
  const showSelect = globalEnvType === "sit" || globalEnvType === "prod" || globalEnvType === "dev";

  const envArray =
    globalEnvType === "sit" || globalEnvType === "dev"
      ? ["DEV", "QA", "UAT", "SIT"]
      : globalEnvType === "prod"
        ? ["PROD", "STG"]
        : [];

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Lock env for non-switchable deployments
  useEffect(() => {
    if (!showSelect && deploymentEnv && env !== deploymentEnv) {
      setEnv(deploymentEnv);
    }
  }, [showSelect, deploymentEnv]);

  // Persist environment
  useEffect(() => {
    if (!env) return;

    dispatch(updateEnv(env));

    const storedEnv = BrowserStorage.getSessionItem("env");

    if (storedEnv !== env) {
      BrowserStorage.setSessionItem("env", env);
      window.location.reload();
    }
  }, [env]);

  return (
    <div
      style={{
        position: "absolute",
        top: "3.65rem",
        right: windowWidth < 1024 ? "60px" : "20px",
        zIndex: 1100,
        backgroundColor: "white",
        borderRadius: "5px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      }}
    >
      {showSelect && (
        <Select
          sx={{
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              borderColor: "black",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "black",
            },
            ".MuiOutlinedInput-notchedOutline": {
              borderColor: "black",
            },
            width: "5.5rem",
            height: "2.5rem",
            fontSize: "14px",
          }}
          value={env}
          onChange={(e) => {
            const selectedEnv = e.target.value.toString();
            setEnv(selectedEnv);

            if (window.location.pathname.startsWith("/application-list/app-")) {
              navigate("/application-list");
            }

            if (window.location.pathname.startsWith("/user-access/")) {
              navigate("/user-access");
            }
            if (window.location.pathname.startsWith("/edit-feature-group/")) {
              navigate("/feature-group");
            }
            if (window.location.pathname.startsWith("/edit-value-streams/")) {
              navigate("/value-streams");
            }
            if (window.location.pathname === "/request-approval") {
              navigate(`/request-approval?env=${selectedEnv}`);
            }
            if (window.location.pathname === "/application-list") {
              navigate(`/application-list?env=${selectedEnv}`);
            }
            if (window.location.pathname === "/dashboard") {
              navigate("/dashboard");
            }
          }}
        >
          {envArray.map((item) => (
            <MenuItem key={item} value={item} sx={{ fontSize: "14px" }}>
              {item}
            </MenuItem>
          ))}
        </Select>
      )}
    </div>
  );
};

export default SitLoginScreen;
